import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Page from "./Components/HomePage/HomePage";
import AuthHandler from "./Components/Authorizaion/Auth"
import NotAuthorized from "./Components/NotAuthorized/NotAuthorized";
import NotFoundPage from "./Components/NotFound/NotFound";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AuthHandler />} />
        <Route path="/Home" element={<AuthHandler />}></Route>
        <Route path="/Page" element={<Page />}></Route>
        <Route path="/NotAuthorized" element={<NotAuthorized />}></Route>
        <Route path="*" element={<NotFoundPage />}></Route>
      </Routes>
    </Router>
  );
}

export default App;
